/**
 * <script src="{{ 'products-combine-submit.js' | asset_url }}" defer="defer"></script>

   var submitResult = await productsCombineUtil(items);
   if (submitResult.status == 200) {
    //
   } else {
      // 
   }

 * @param {*} items [{ id: "variant_id", quantity: 1 }]
 * @returns 
 */
function productsCombineUtil(items = []) {
  return new Promise((resolve) => {

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then((response) => {
      try {
        return response.json();
      } catch (e) {
        resolve({ status: 0, channel: "then: /cart/add.js try catch", msg: "error", msg: e });
      }
    })
    .then((cart) => {
      if (!Array.isArray(cart?.items)) {
        resolve({ status: 0, channel: "then: /cart/add.js cart", msg: "error", cart: cart });
        return;
      }

      /**
       * 调用 ?sections=cart-drawer,cart-icon-bubble 获取两个板块的 HTML
       *
       * 替换页面上的购物车角标（数量提示）
       * 替换整个购物车抽屉组件
       */
      fetch('?sections=cart-drawer,cart-icon-bubble')
      .then((response) => response.json())
      .then((sections) => {
        // 获取DOM元素（一次性查询，提升性能）
        var oldCartDrawerEl = document.querySelector('cart-drawer');
        var cartBubbleEl = document.getElementById('cart-icon-bubble');

        // 更新购物车数量角标（如果元素存在）
        if (cartBubbleEl && sections['cart-icon-bubble']) {
          var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var bubbleContent = parsedBubble.querySelector('.shopify-section')?.innerHTML;
          if (bubbleContent) cartBubbleEl.innerHTML = bubbleContent;
        }

        // 替换购物车抽屉组件（如果元素存在）
        if (oldCartDrawerEl && sections['cart-drawer']) {
          var parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newCartDrawerEl = parsedDrawer.querySelector('cart-drawer');

          if (newCartDrawerEl) {
            // 替换DOM
            oldCartDrawerEl.replaceWith(newCartDrawerEl);
            // 打开新的购物车抽屉
            document.querySelector('cart-drawer')?.open();
          }
        }

        resolve({ status: 200, channel: "then: ?sections=cart-drawer,cart-icon-bubble", msg: "success", cart: cart });
      })
      .catch((error) => {
        resolve({ status: 0, channel: "catch: ?sections=cart-drawer,cart-icon-bubble", msg: "error", msg: error });
      });
    })
    .catch((error) => {
      resolve({ status: 0, channel: "catch: /cart/add.js", msg: "error", msg: error });
    });


  });
}